/* eslint-disable max-lines-per-function */
import React, { useEffect, useState } from "react";

import { Grid } from "@material-ui/core";
import { useField } from "formik";
import { KeyboardDatePicker } from "@material-ui/pickers";
import moment from "moment";
import { Input } from "components/haven-design/form/inputs";
import { SelectAutocomplete } from "components/haven-design/form/select";

export const PossiblePropManagerRemovalReasons = [
  "Accidentally Applied",
  "Credit Denied",
  "Criminal Background Denied",
  "Deceased",
  "Did not submit requested documents",
  "Duplicate application",
  "Found another home",
  "Fraud in application process",
  "Full time student household",
  "Justice involvement screening",
  "Looking for different housing type",
  "No longer interested",
  "No response to interview request",
  "No response to outreach",
  "No response to waitlist update",
  "No show to interview",
  "Not chosen in lottery",
  "Over Income",
  "Refused background check",
  "Requested to be removed",
  "Too expensive for applicant",
  "Turned down/skipped too many times",
  "Unable to accommodate ADA unit",
  "Unable to accommodate household size",
  "Unable to accommodate pets",
  "Unable to contact",
  "Under age limit",
  "Under Income",
  "Other",
];

export const PossibleClientRemovalReasons = [
  "No longer interested",
  "Too far away",
  "Don't like the neighborhood",
  "Too expensive",
  "Found other housing",
  "Not income qualified",
  "Want different unit size",
  "My household size doesn't fit the unit requirements",
  "Duplicate application",
  "Other",
];

export const PossibleWaitlistUpdateRemovalReasons = [
  "Found other housing",
  "Passed away",
  "Medical reasons",
  "Moved to another city",
  "No longer interested - I don't want to be on the list anymore",
  "This isn't my phone number or email and I don't want any more notifications",
  "Other",
];

export type StructuredReasonsProps = {
  label: string
  options?: string[]
  disabled?: boolean
  onChange: (reason: string) => void
}

const StructuredReasons: React.FC<StructuredReasonsProps> = ({
  disabled,
  onChange,
  options = PossiblePropManagerRemovalReasons,
  label,
}) => {
  const [reason, setReason] = useState<string | null>(null);
  const [other, setOther] = useState("");
  const [actionDate, setActionDate] = React.useState<Date | null>(new Date());

  const handleChange = () => {
    let fullReason = reason ?? "";
    const actionDateString = moment(actionDate).format("MM/DD/YYYY");
    if (reason === "Other") {
      fullReason = other ? `${reason} - ${other}` : "";
    }
    if (fullReason !== "") fullReason = `${actionDateString} - ${fullReason}`;
    onChange(fullReason);
  };

  useEffect(handleChange, [reason, other, actionDate]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={4}>
        <KeyboardDatePicker
          fullWidth
          required
          disableFuture
          autoComplete="off"
          autoOk
          variant="inline"
          inputVariant="outlined"
          label="Removal Date"
          format="MM/dd/yyyy"
          InputAdornmentProps={{ position: "end" }}
          value={actionDate}
          onChange={setActionDate}
        />
      </Grid>
      <Grid item xs={12} sm={8}>
        <SelectAutocomplete
          label={label}
          disabled={disabled}
          options={options}
          value={reason}
          margin="none"
          onChange={(_, value) => setReason(value)} />
      </Grid>

      {reason === "Other" && (
        <Grid item xs={12}>
          <Input
            required
            name="other"
            label="Reason"
            disabled={disabled}
            value={other}
            onChange={(e) => setOther(e.target.value)} />
        </Grid>
      )}
    </Grid>
  );
};

export type FormikStructuredReasonsProps = {
  name: string
} & Omit<StructuredReasonsProps, "onChange">

export const FormikStructuredReasons: React.FC<FormikStructuredReasonsProps> = ({
  name,
  ...props
}) => {
  const [,, { setValue }] = useField<string>(name);

  return <StructuredReasons {...props} onChange={setValue} />;
};

export default StructuredReasons;
